import { useEffect, useState } from "react";
import { throttle } from "utils/throttle";
import { useBreakpoint } from "hooks/useBreakpoint";

export const useOffsetTop = () => {
  const [offsetOpt, setOffsetTop] = useState(0);
  const { isDesktop } = useBreakpoint(1);

  useEffect(() => {
    let handler: (() => void) | null = null;
    const layout = document.getElementById("profile-layout");

    if (isDesktop) {
      if (layout) {
        handler = throttle(() => {
          setOffsetTop(layout.scrollTop ?? 0);
        }, 100);
        layout.addEventListener("scroll", handler as () => void);
      }
    } else {
      handler = throttle(() => {
        setOffsetTop(window.scrollY ?? 0);
      }, 100);
      window?.addEventListener("scroll", handler as () => void);
    }

    return () => {
      window?.removeEventListener("scroll", handler as () => void);
      layout?.addEventListener("scroll", handler as () => void);
    };
  }, [isDesktop, offsetOpt]);

  return offsetOpt;
};
